const messages = {
    pt:{
        translations: {/* ns e default ns*/
            
            titulos:{
                titulo: 'Abacaxi',
                tituloSobre: 'Sobre o Abacaxi',
                Efruta: 'É fruta mesmo?'
            },

            textos:{
                abacaxi:'Os abacaxis são frutas tropicais amareladas.',
                abacaxiSobre: 'O abacaxi é um bom aliado. Afinal de contas, possui vitaminas, minerais e enzimas, como a bromelina. Esses nutrientes ajudam a fortalecer o sistema imunológico e eliminar as inflamações do corpo. Ajuda na perda de peso: sendo um alimento diurético, o abacaxi ajuda na eliminação de líquidos e toxinas do organismo.',
                abacaxiE: 'Abacaxi, morango e figo são frutas, certo? Errado! Eles são infrutescência: resultado da fusão de várias flores que, após serem fecundadas, se juntam em um único fruto ou infrutescência.'
            },

            seletores:{
                escolhaIdioma: 'Escolha um idioma',
                idioma1: 'Português (Brasil)',
                idioma2: 'Inglês (EUA)',
                idioma3: 'Espanhol (Espanha)',
            },

            botoes:{
                comprarAbacaxi: 'Comprar?'
            }
        }
    }
}
export {messages}